import { useCommissionComments } from 'hooks/queries/commissions/useCommissionComments';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Card, CardHeader } from 'shared/mui/Card';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { CommissionsComment } from 'shared/react-admin/CommissionsComment/CommissionsComment';
import { Commission } from 'types/embedded/commission';
import { truncateString } from 'utils/truncateString';

import { CardContentStyled } from './CommissionsCommentDialog.styled';
import { CommissionsCommentSkeleton } from '../../react-admin/CommissionsComment/CommissionsCommentSkeleton';

type Props = DialogProps & {
  record: Commission | undefined;
};

export const CommissionsCommentDialog: React.FC<Props> = ({ record, ...restProps }) => {
  const translate = useTypedTranslate();

  const { comments, isLoading } = useCommissionComments(record?.originId, restProps.open);

  return (
    <Dialog width="640px" {...restProps} fullWidth>
      <RecordContextProvider value={record}>
        <Card>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
            sx={{ height: 'auto' }}
            title={
              <>
                {translate('app.merchantCommissions.feeComments')}{' '}
                {truncateString(record?.name || '', 30)}
              </>
            }
            titleSize="smallBold"
          />
          <CardContentStyled>
            {isLoading ? (
              <CommissionsCommentSkeleton />
            ) : (
              comments.map((comment) => (
                <RecordContextProvider key={comment.id} value={comment}>
                  <CommissionsComment />
                </RecordContextProvider>
              ))
            )}
          </CardContentStyled>
        </Card>
      </RecordContextProvider>
    </Dialog>
  );
};
